import Video from './MdxVideo';

export default Video;
